export default __webpack_public_path__ + "files/gltg-banner-372a88e349d2f196874bec7ee338ae35.jpg";